<script setup lang="ts" name="FormWizardHorizontalHeader">
import FormWizardHorizontalTab from '~/components/FormWizardHorizontalTab.vue';

import type { IStepperStep } from '~/types';

defineProps<{
  totalSteps: number;
  activeStepIdx: number;
  steps?: IStepperStep[];
  setCurrentTab: (index: number) => void;
}>();
</script>

<template>
  <div class="mb-2 flex rounded bg-white shadow">
    <FormWizardHorizontalTab
      v-for="step in totalSteps"
      :key="step"
      :step="step"
      :activeStepIdx="activeStepIdx"
      :setCurrentTab="setCurrentTab"
      :title="steps?.[step - 1].title"
      :disabled="steps?.[step - 1].disabled"
    />
  </div>
</template>
